export const Constant = {
  UID: "health-uid",
  WX_ASSESS_TOKEN: "wx_assess_token",
  WX_REFRESH_TOKEN: "wx_refresh_token",
  WX_OPEN_ID: "wechat_open_id_0",
  WX_NICKNAME: "wx_nick_name",
}
